<template>
  <div class="media-preview-dialog">
    <el-dialog
      v-if="player.dialog"
      id="playVideoDialog"
      class="media-preview-dialog z-998 bg-black/50"
      :z-index="998"
      :model-value="player.dialog"
      :close-on-click-modal="false"
      :modal="false"
      :show-close="false"
      @close="$emit('close')">
      <button class="absolute top-[10px] right-[14px]" @click="$emit('close')">
        <font-awesome-icon icon="fa-solid fa-xmark"/>
      </button>
      <video autoplay controls class="inline-block">
        <source v-for="(videopreview, key) in player.videopreviews"
          :key="key"
          :src="$utils.filterMediaPreviewUrl(videopreview.url)"
          :type="videopreview.format"
        />
      </video>
    </el-dialog>
  </div>
</template>

<script src="./video-player-dialog.js"></script>
